<div class="flex-center width-50">
    <div style="width: 50px; height: 50px">
        <ng-lottie [options]="options" [styles]="{width: '50px', height: '50px'}"></ng-lottie>
    </div>

</div>
